<template>
  <time-line 
    :itens="itensTimeLine"
  >
  </time-line>
</template>

<script>
import TimeLine from './../../../shared/components/TimeLine'

export default {
  props: {
    pagamentosServicos: {
        type: Object,
        required: true,
        default: () => ({})
    },
    pagamento: {
      type: Object,
      required: true,
      default: () => ({}) 
    }
  },

  data() {
    return {
      itensTimeLine: null
    }
  },

  methods: {
    obterTimeLine() {
      this.pagamentosServicos.obterTimeLine(this.pagamento.pagamentoId).then(
        response => {
          if (response){
            if (response.success) {
              this.itensTimeLine = response.data
            } else {
              this.$toast.error(
                "Erro ao obter timeline",
                "ERROR",
                this.$toastConfig.error
              );
            }
          }
        })
    }
  },

  created() {
    this.obterTimeLine()
  },

  components: {
    TimeLine
  },

}       
</script>

<style>
</style>